import React from 'react';

const MailLogo = (props) => {
	return (
		<div class="mail_logo mod_align_center">
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<g>
					<polygon points="10.19,15.9 2.5,7.51 2.5,22.67"/>

					<polygon points="27.5,22.67 27.5,7.51 19.81,15.9"/>

					<path d="M15,17.75c0.95,0,1.85-0.45,2.82-1.43L27.27,7H2.73l9.45,9.32C13.15,17.3,14.05,17.75,15,17.75z"/>

					<path d="M19.47,16.27l-1.29,1.4c-0.98,1.08-1.99,1.58-3.18,1.58c-1.2,0-2.21-0.5-3.19-1.58l-1.29-1.4L2.88,23h24.24L19.47,16.27z"/>
				</g>
			</svg>

		</div>
	)
}

export default MailLogo;